import { BlogPost } from '@/types/blog';
import { content } from './content';
import etfMythosHero from '@/assets/blog/etf-mythos-hero.webp';

export const etfMythosPost: BlogPost = {
  title: "Der Mythos vom ewigen Sieg der ETFs: Warum die passive Revolution die falschen Fragen beantwortet",
  metaTitle: "ETF-Mythos: Passive vs. aktive Geldanlage | Analyse",
  excerpt: "93% aller aktiven Fonds scheitern am Benchmark. Doch der 1,1% Behavioral Gap ist oft größer als die Kostenersparnis. Eine differenzierte Analyse jenseits der Ideologie.",
  date: "19.10.2025",
  slug: "etf-mythos",
  imageUrl: etfMythosHero,
  category: "Finanzpsychologie",
  tags: ["Finanzpsychologie", "ETF", "Aktives Fondsmanagement", "Behavioral Finance", "Stewardship", "Investmentphilosophie"],
  author: "Jörg Hörmann",
  authorTitle: "Finanzpsychologe & systemischer Coach",
  readingTime: 12,
  metaDescription: "Über 25 Jahre Erfahrung in aktiver und passiver Geldanlage zeigen: Weder ETFs noch aktive Fonds sind per se überlegen. Entscheidend ist Bewusstsein.",
  content
};
